import { useMemo } from "react";
import { Leaf } from "lucide-react";

export const FloatingLeaves = ({ count = 14 }) => {
  const leaves = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 12,
        duration: 12 + Math.random() * 12,
        size: 14 + Math.random() * 20,
        opacity: 0.15 + Math.random() * 0.35,
      })),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {leaves.map((l) => (
        <span
          key={l.id}
          className="absolute top-0 animate-[leaffall_linear_infinite] [animation-fill-mode:backwards]"
          style={{
            left: `${l.left}%`,
            animationDelay: `${l.delay}s`,
            animationDuration: `${l.duration}s`,
            opacity: 0,
          }}
        >
          <Leaf
            className="text-gold"
            style={{ width: l.size, height: l.size, opacity: l.opacity }}
          />
        </span>
      ))}
    </div>
  );
};
